import * as React from 'react';

function CeoCompensation({data} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Recent CEO Compensation</h4>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>CEO</td>
                  <td>{data.ceo_compensation.name}</td>
                </tr>
                <tr>
                  <td>Year</td>
                  <td>{data.ceo_compensation.year}</td>
                </tr>
                <tr>
                  <td>Salary</td>
                  <td>{data.ceo_compensation.salary_in_words}</td>
                </tr>
                <tr>
                  <td>Stock Awards</td>
                  <td>{data.ceo_compensation.stock_awards_in_words}</td>
                </tr>
                <tr>
                  <td>Option Awards</td>
                  <td>{data.ceo_compensation.option_awards_in_words}</td>
                </tr>
                <tr>
                  <td>Non equity incentives</td>
                  <td>{data.ceo_compensation.non_equity_incentives_in_words}</td>
                </tr>
                <tr>
                  <td>Pension and deferred</td>
                  <td>{data.ceo_compensation.pension_and_deferred_in_words}</td>
                </tr>
                <tr>
                  <td>Other compensation</td>
                  <td>{data.ceo_compensation.other_comp_in_words}</td>
                </tr>
                <tr>
                  <td>Total compensation</td>
                  <td>{data.ceo_compensation.total_in_words}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CeoCompensation;
